import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import * as styles from './ResendButton.scss';

class ResendButton extends React.Component {
  render() {
    const { isLoading, disabled, translate, onClick, isTimerRunning } = this.props;
    return (
      <button
        className={cx('btn btn-default', styles.resendButton)}
        onClick={onClick}
        disabled={disabled}
        type="button"
      >
        {isLoading ? (
          <i className="icon icon-om-spinner om-pulse" />
        ) : (
          <span
            style={{
              paddingLeft: isTimerRunning ? '20px' : '5px',
              paddingRight: isTimerRunning ? '20px' : '5px'
            }}
            className="button-text"
          >
            {translate(
              'authenticationPage',
              isTimerRunning ? 'sendCodeAgain' : 'sendCodeAgainFull'
            )}
          </span>
        )}
      </button>
    );
  }
}

ResendButton.propTypes = {
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  isTimerRunning: PropTypes.bool,
  translate: PropTypes.func,
  onClick: PropTypes.func
};

export default ResendButton;
